<template>
  <CCol md="6">
    <div class="w-100">
      <div class="clearfix">
        <h1 class="float-left display-3 mr-4">404</h1>
        <h4 class="pt-3">{{ $t("oops_youre_lost") }}.</h4>
        <p class="text-muted">
          {{ $t("the_page_you_are_looking_for_was_not_found") }}.
        </p>
      </div>
      <div class="float-right w-80 px-2">
        <CButton block color="info" @click="$router.push({ path: '/' })">
          {{ $t("go_home") }}
        </CButton>
      </div>
    </div>
  </CCol>
</template>

<script>
export default {
  name: "Page404",

  layout: "basic",

  metaInfo() {
    return { title: `404. ${this.$t("page_not_found")}` };
  },

  methods: {
    goBack() {
      this.$router.push({ name: "welcome" })
    }
  } 
};
</script>
